import { useState, useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { BannerLogin } from '../../components/header';
import { Alert } from '../../components/modal';

import { useError } from '../../hooks/useError';

import { TransactionContext } from '../../contexts/TransactionContext';
import { isEmpty } from '../../helpers/validation';

import { getTickets } from '../../services/product';

import { EVENTID } from '../../helpers/constants';

import { getCPS } from '../../services/cp';

import {
  Row,
  Col,
  Input,
  InputGroup,
  ListGroup,
  ListGroupItem,
} from 'reactstrap';
export default function Login() {
  const [t] = useTranslation();
  const navigate = useNavigate();
  const [cps, setCps] = useState([]);
  const [cp, setCp] = useState('');
  const [cp_code, setCp_code] = useState('');

  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState('');
  const [filteredOptions, setFilteredOptions] = useState([]);
  const [isListVisible, setIsListVisible] = useState(false);
  const { fillCp, cpSelected } = useContext(TransactionContext);
  const { goToFieldWithError } = useError();

  const openModal = () => {
    setOpen(true);
  };

  const closeModal = () => {
    setOpen(false);
    goToFieldWithError('home-cp');
  };

  const handleNext = async (e) => {
    e.preventDefault();
    const result = cps.find(
      (x) => x.name.toLowerCase() === cp.toLowerCase() && x.code === cp_code,
    );
    console.log(cp);

    if (!result) {
      setMessage('Código do CP não confere');
      openModal();
      return;
    }
    // if (cpSelected?.focal_point?.trim() === '') {
    //   setMessage('Ponto focal não preenchido');
    //   openModal();
    //   return;
    // }
    if (result && result?.available) {
      fillCp('code', result.code);
      fillCp('name', result.name);
      fillCp('count', result.count);
      navigate('/carrinho');
    } else {
      setMessage('CP não tem vagas disponíveis');
      openModal();
    }
  };

  const handleSearch = (e) => {
    const term = e.target.value;
    setCp(term);
    const filtered = cps.filter((option) =>
      option.name.toLowerCase().includes(term.toLowerCase()),
    );
    setFilteredOptions(filtered);
    setIsListVisible(true);
  };

  const handleSelect = (selectedOption) => {
    setCp(selectedOption.name);
    setIsListVisible(false);
    if (!selectedOption.available) {
      setMessage('CP não tem vagas disponíveis');
      openModal();
    }
  };

  const toggleListVisibility = () => {
    setIsListVisible(!isListVisible);
  };

  const modal = (
    <Alert
      isOpen={open}
      toggle={closeModal}
      message={message}
    />
  );

  const associatedLogin = (
    <>
      <form
        onSubmit={handleNext}
        className='w-100'
        style={{ maxWidth: '300px' }}
      >
        <Row className='w-100 justify-content-center'>
          <Col className='w-100 justify-content-center col-md-3 mb-3'>
            <label
              htmlFor='login-document'
              className='form-label'
            >
              <strong>Selecione o seu CP *</strong>
            </label>
            <InputGroup>
              <Input
                id={'home-cp'}
                placeholder='Pesquisar...'
                value={cp}
                onChange={handleSearch}
                onClick={toggleListVisibility}
                style={{ width: '100%' }}
              ></Input>
            </InputGroup>

            {isListVisible && (
              <ListGroup
                style={{
                  maxHeight: '100px',
                  overflow: 'auto',
                }}
              >
                {filteredOptions.map((cp, index) => (
                  <ListGroupItem
                    key={index}
                    value={cp.name}
                    action
                    onClick={() => handleSelect(cp)}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        setCp(cp.name);
                        setIsListVisible(false);
                        if (!cp.available) {
                          setMessage('CP não tem vagas disponíveis');
                          openModal();
                        }
                      }
                    }}
                    tabIndex={0}
                  >
                    {cp.name}
                  </ListGroupItem>
                ))}
              </ListGroup>
            )}
          </Col>
        </Row>
        <Row className='w-100 justify-content-center'>
          <Col className='w-100 justify-content-center col-md-3 mb-3'>
            <label
              htmlFor='cp_code'
              className='form-label'
            >
              <strong>Código do CP *</strong>
            </label>
            <Input
              id='cp_code'
              placeholder='Digite o código do CP'
              value={cp_code}
              onChange={(e) => setCp_code(e.target.value)}
            />
          </Col>
        </Row>
        {/* <Row className='w-100 justify-content-center'>
          <Col className='w-100 justify-content-center col-md-3 mb-3'>
            <label
              htmlFor='focal_point'
              className='form-label'
            >
              <strong>
                Nome Completo Ponto Focal (Contato para Comunicações e
                Pagamentos) *
              </strong>
            </label>
            <Input
              id='focal_point'
              placeholder='Digite o ponto focal'
              value={cp.focal_point}
              onChange={(e) => fillCp('focal_point', e.target.value)}
            />
          </Col>
        </Row> */}
        <Row className='w-100 justify-content-center'>
          <Col className='w-100 justify-content-center col-md-3 mb-3'>
            <button
              type='submit'
              className='btn btn-secondary w-100'
            >
              <i className='bi bi-box-arrow-in-right me-2' />
              Entrar
            </button>
          </Col>
        </Row>
      </form>
    </>
  );

  useEffect(() => {
    const fetch = async () => {
      document.title = t('title');
      const response = await getCPS();
      setCps(response);
      setFilteredOptions(response);
    };
    fetch();
  }, [open, t]);

  return (
    <>
      <main className='d-flex flex-column justify-content-center align-items-center vh-100'>
        {modal}
        <BannerLogin />
        {associatedLogin}
      </main>
    </>
  );
}
